import css from './index.module.scss';
import EFEmail from '@/components/UI/svg/WTB/EFEmail';
import EFPhone from '@/components/UI/svg/WTB/EFPhone';
import EFClock from '@/components/UI/svg/WTB/EFClock';
import EFGlobal from '@/components/UI/svg/WTB/EFGlobal';
import EFLocation from '@/components/UI/svg/WTB/EFLocation';
import { useGlobal } from '@/utils/useGlobal';
import EFNoData from '@/components/UI/svg/WTB/EFNoData';

export default function StoreList({ storeLists, onRecordClick }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('wheretobuy');
    return (
        <div className={`recordBox ${css.recordBox}`}>
            {storeLists?.map((storeList: any, k: number) => (
                <li className="store_item" key={`${storeList?.latitude}_${storeList.longitude}_record_${k}`} onClick={() => onRecordClick(storeList)}>
                    {storeList?.name && <div className="store_name">{storeList?.name}</div>}
                    {storeList?.address && !storeList?.virtualFlag && (
                        <div className="store_address common">
                            <div className="icon">
                                <EFLocation />
                            </div>
                            <div className="text">{storeList?.address}</div>
                        </div>
                    )}
                    {storeList?.phone && (
                        <div className="store_phone common">
                            <div className="icon">
                                <EFPhone />
                            </div>
                            <a className="text" href={`tel:${storeList?.phone}`}>
                                {storeList?.phone}
                            </a>
                        </div>
                    )}
                    {storeList?.email && (
                        <div className="store_email common">
                            <div className="icon">
                                <EFEmail />
                            </div>
                            <a className="text" href={`mailto:${storeList?.email}`}>
                                {storeList?.email}
                            </a>
                        </div>
                    )}
                    {storeList?.webLink && (
                        <div className="store_website common">
                            <div className="icon">
                                <EFGlobal />
                            </div>
                            <a className="text" href={storeList?.webLink} target="_blank" onClick={(e: any) => e.stopPropagation()} rel="noreferrer">
                                {storeList?.webLink}
                            </a>
                        </div>
                    )}
                    {storeList?.businessTime && (
                        <div className="store_openTime common">
                            <div className="icon">
                                <EFClock />
                            </div>
                            <div className="text">{storeList?.businessTime}</div>
                        </div>
                    )}
                    {storeList?.label && (
                        <div className="store_tags">
                            {storeList?.label?.split(';')?.map((tag: any, m: number) => (
                                <li className="store_tag_item" key={`${storeList.latitude}_${storeList.longitude}_record_${k}_tag_${m}`}>
                                    {tag}
                                </li>
                            ))}
                        </div>
                    )}
                </li>
            ))}
            {storeLists.length === 0 && (
                <div className="noDataBox">
                    <EFNoData />
                    <p className="noData">{t('noData')}</p>
                </div>
            )}
        </div>
    );
}
